import { render, staticRenderFns } from "./KonfirmasiIdentitas.vue?vue&type=template&id=59f12660&scoped=true"
import script from "./KonfirmasiIdentitas.vue?vue&type=script&lang=js"
export * from "./KonfirmasiIdentitas.vue?vue&type=script&lang=js"
import style0 from "./KonfirmasiIdentitas.vue?vue&type=style&index=0&id=59f12660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f12660",
  null
  
)

export default component.exports